import { MARQUEE_ITEMS } from '../data';

export const Marquee = () => {
    const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            data-testid="loan-marquee"
            className="relative overflow-hidden border-y border-white/10 bg-[#0D111A] py-5"
        >
            <div className="flex whitespace-nowrap animate-marquee w-max">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center" aria-hidden={half === 1}>
                        {row.map((item, i) => (
                            <span
                                key={`${half}-${i}`}
                                className="flex items-center font-display text-lg sm:text-xl font-semibold tracking-tight text-slate-400"
                            >
                                <span className="px-6">{item}</span>
                                <span className="text-emerald-500 text-xs">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
